import React from 'react';
import { Link } from 'react-router-dom';

export function CTA() {
  return (
    <section className="py-24 px-6">
      <div className="mx-auto max-w-3xl">
        <div className="relative rounded-2xl p-px overflow-hidden">
          {/* Gradient border */}
          <div
            className="absolute inset-0 rounded-2xl"
            style={{
              background: 'linear-gradient(135deg, rgba(99,102,241,0.5) 0%, rgba(139,92,246,0.3) 50%, rgba(99,102,241,0.1) 100%)',
            }}
          />
          {/* Inner card */}
          <div className="relative rounded-2xl bg-[#0d0d1a] px-8 py-12 text-center">
            <div
              className="absolute inset-0 rounded-2xl pointer-events-none"
              style={{
                background: 'radial-gradient(ellipse at 50% 0%, rgba(99,102,241,0.12) 0%, transparent 60%)',
              }}
            />
            <div className="relative inline-flex items-center gap-2 text-xs font-mono text-green-400 bg-green-500/10 border border-green-500/20 px-3 py-1 rounded-full mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" />
              Your first 50 minutes are free
            </div>
            <h2 className="relative text-3xl md:text-4xl font-bold text-white tracking-tight mb-3">
              Your AI calling team is ready.<br />Are you?
            </h2>
            <p className="relative text-zinc-400 mb-8 max-w-md mx-auto">
              Set up your first campaign in 5 minutes. No credit card. No SDR budget. Just calls.
            </p>
            <div className="relative flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/register"
                className="bg-indigo-600 hover:bg-indigo-500 text-white font-semibold px-8 py-3.5 rounded-lg transition-colors text-base w-full sm:w-auto"
              >
                Start calling for free →
              </Link>
              <Link
                to="/register"
                className="border border-white/15 hover:border-white/30 text-zinc-300 hover:text-white font-medium px-8 py-3.5 rounded-lg transition-colors text-base w-full sm:w-auto"
              >
                Talk to sales
              </Link>
            </div>
            <p className="relative mt-4 text-xs text-zinc-600 font-mono">No credit card · 14-day trial on paid plans · cancel anytime</p>
          </div>
        </div>
      </div>
    </section>
  );
}
